import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const FeatureList = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${({ theme }) => theme.spacing(4)};
  grid-column-gap: ${({ theme }) => theme.spacing(6)};

  margin: 0;
  padding: 0;

  list-style: none;

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.sm)} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  min-width: 0;
`;

export const FeatureIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  font-size: 2rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const FeatureLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;
